import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import sessionStore from './stores/AuthStore';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment'

//TODO rename file to main.ts and remove 'src/main.js' from  packages.json by serve and build command to enable typescript
Vue.config.productionTip = false
Vue.prototype.moment = moment
new Vue({
  router,
  vuetify,
  sessionStore,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  render: h => h(App)
}).$mount('#app')
